module.controller('consumerChoiceCreateCtrl', ['giftAuthService', '$window', '$timeout', 'Transform', 'baseURI', '$state', '$http', '$stateParams', '$scope', 'brandService', function(giftAuthService, $window, $timeout, Transform, baseURI, $state, $http, $stateParams, $scope, brandService) {
  var giftVirtualRegisterUrl = baseURI + 'gift-card/collect/virtual';

  // allow email change if none was provided or is populated with a phone number
  if (!$stateParams.email || !$stateParams.email.includes('@')) {
    $scope.canChangeEmail = true;
  }

  if($stateParams.redirect.state === 'member.home.virtual.step1'){
    $scope.collectType = 'View Virtual Mastercard';
  } else if($stateParams.redirect.state === 'member.home.ach.step1' || $stateParams.redirect.state === 'member.home.bank/add.step1'){
    $scope.collectType = 'Withdraw to Bank Account';
  } else {
    $scope.collectType = 'Receive a Paper Check';
  }

  // step 2
  $scope.passwordInputType = 'password';
  $scope.showValidateEmail = false;
  $scope.loadingEmailVerification = false;
  $scope.collectEmailLabel = "New Email";

  // lets set the email or phone number
  // set parent view form class
  $scope.parent.formType = 'floatingForm-form';

  var goToSuccessPage = function(message) {
    $state.go('root.redeem.success', {
      successMessage: message,
      username: $scope.formData.email,
    });
  };

  $scope.attemptSubmission = function(joinForm){
    if(joinForm.$valid){
      verifyEmail();
    } else {
      $scope.submitted = true;
    }
  };

  $scope.goBack = function() {
    $window.history.back();
  };

  var submitRegistration = function(){
    $scope.parent.overlayLoading = true;
    var formData = $scope.formData;

    var updatedEmail = $scope.canChangeEmail ? $scope.formData.email : '';

    var request = {
      FirstName: formData.firstName,
      LastName: formData.lastName,
      Username: $scope.formData.email,
      Email: $scope.formData.email,
      NewEmail: updatedEmail,
      Phone: formData.phone,
      Password: formData.password
    };

    $http({
      method: 'POST',
      url: giftVirtualRegisterUrl,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(request)
    }).then(function (resp){
      var data = resp.data;

      $scope.parent.overlayLoading = false;
      data.email = request.Email;

      if($scope.formData.textAlerts){
        // set txt alerts for primary
        // if sub, set the subcard username
        data.textAlerts = {
          phoneNumber: $scope.formData.phone,
          subcard: null
        };
      } else {
        data.textAlerts = false;
      }
      if(typeof data.Data.OAuthData === "undefined" || data.Data.OAuthData === null) {
        var successMessage = "We found an existing account for you and have applied these funds to that account. Please log in to your existing account to see these funds.";
        goToSuccessPage(successMessage);
      } else {
        // Scroll to top
        $window.scrollTo(0,0);
        giftAuthService.handleAuth(data, $scope.formData.VerificationCode, $stateParams.redirect);
      }
    }).catch(function(err){
      $scope.parent.overlayLoading = false;
      $scope.alertError.show = true;
      $scope.alertError.message = 'Oops, we are unable to register your card at this time.';
    });
  };

  // Verification email process
  var verifyEmail = function(){
    if (!$stateParams.email.includes('@')) { // phone was provided instead of email, verify on phone
      $scope.formData.verificationMethod = 'phone';
    } else {
      $scope.formData.verificationMethod = 'email';
    }

    $scope.verificationMethodIsPhone = $scope.formData.verificationMethod === 'phone';
    $scope.verificationMethodIsEmail = $scope.formData.verificationMethod === 'email';

    createVerificationCode();
  };

  // Make request for validation Code
  var createVerificationCode = function(){
    $scope.loading = true;

    var reqData = {
      VerificationType: $scope.formData.verificationMethod,
      Contact: $scope.formData.verificationMethod === 'phone' ? $scope.formData.phone : $scope.formData.email,
      _key: $scope.brand.api_key
    };

    var errorFn = function(errorCode) {
      switch(errorCode){
        case 31:
          $scope.alertError.cardNotFoundLinkLogin = true;
          break;

        default:
          $scope.alertError.message = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
      }
      $scope.loading = false;
      $scope.alertError.show = true;
    };

    $http.get(giftVirtualRegisterUrl + '?Email=' +  encodeURIComponent($scope.formData.email) + '&Phone=' + $scope.formData.phone)
      .then(function(resp){
        $http({
          url: baseURI + 'member/verification',
          method: 'POST',
          headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
          data: Transform.encode(reqData)
        }).then(function(resp){
          var data = resp.data;
          $scope.loading = false;
          if(data.Success){
            // Open the modal
            $scope.showValidateEmail = true;
            startCountDown();
          } else {
            errorFn(resp.data.ErrorCode);
          }
        }).catch(function(error){
          errorFn(error.data.ErrorCode);
        });
      }).catch(function(error){
        errorFn(error.data.ErrorCode);
      });
  };

  // User is manually submitting code
  $scope.submitCode = function(){
    if(!$scope.formData.VerificationCode){
      $scope.attemptedVerify = true;
      $scope.invalidVerify = false;
    } else {
      $scope.loading = true;
      $scope.attemptedVerify = false;
      var verifiedReq = {
        VerificationType: $scope.formData.verificationMethod,
        Contact: $scope.formData.verificationMethod === 'phone' ? $scope.formData.phone : $scope.formData.email,
        VerificationCode: $scope.formData.VerificationCode
      };

      $http({
        url: baseURI + 'member/verification',
        method: 'PUT',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: Transform.encode(verifiedReq)
      }).then(function(resp){
        var data = resp.data;

        $scope.loading = false;
        $scope.invalidVerify = !data.Success;
        if(data.Success){
          $scope.stopTimeout();
          successVerfication();
        }
      }).catch(function(error){
        $scope.invalidVerify = true;
        $scope.loading = false;
      });
    }
  };

  // User clicks on resend email link
  $scope.reSend = function(){
    $scope.stopTimeout();
    $scope.loadingEmailVerification = true;
    createVerificationCode();
  };

  // Close the modal
  $scope.close = function(){
    if ($scope.showSelectVerificationMethod) {
      $scope.showSelectVerificationMethod = false;
    }
    else {
      $scope.stopTimeout();
      $scope.showValidateEmail = false;
    }
  };

  // User has successfully completed email verification
  var successVerfication = function(){
    $scope.$parent.verifiedEmail = true;
    $scope.loadingEmailVerification = true;
    $scope.showValidateEmail = false;

    submitRegistration();
  };

  var startCountDown = function() {
    $scope.counter = 1200;

    $scope.onTimeout = function(){
      $scope.counter--;
      if($scope.counter > 1){
        myTimeout = $timeout($scope.onTimeout, 1000);
      } else {
        $scope.stopTimeout();
        $scope.showValidateEmail = false;
      }
    };

    // Create the promise
    var myTimeout = $timeout($scope.onTimeout, 1000);

    // Cancel the promise
    $scope.stopTimeout = function() {
      $timeout.cancel(myTimeout);
    };
  };
}]);
